import { useBrowserStore } from '@/hooks/data/browser/useBrowserStore';
import { useRouter } from 'next/router';

/**
 * Whether the app is currently in "search mode", derived directly from the URL.
 *
 * Search is active when the URL carries a `query` param (including an empty string,
 * e.g. `?query=`) or any `filters`. While locating an asset we are browsing, not
 * searching, so search is suppressed.
 *
 * ℹ️ This is intentionally derived state — there is no stored boolean to fall out of
 * sync with the URL. Navigating away from a search (dropping the query/filters params)
 * automatically deactivates search.
 */
export const useIsSearching = (): boolean => {
  const { query } = useRouter();
  const locateAssetId = useBrowserStore((state) => state.locateAssetId);

  if (locateAssetId) {
    return false;
  }

  return query?.query !== undefined || Boolean(query?.filters);
};
